/* unplugin-vue-components disabled */import { render } from "./Login.vue?vue&type=template&id=1515cdf2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=1515cdf2&scoped=true&lang=css"
import "./Login.vue?vue&type=style&index=1&id=1515cdf2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1515cdf2"]])

export default __exports__